import React from "react";
import PropTypes from "prop-types";
import cl from "classnames";
import loadable from "./loadable";

const PrimaryButton = ({ className = "", ...props }) => (
  <button className={cl("button button--dark", className)} {...props} />
);

PrimaryButton.propTypes = {
  className: PropTypes.string,
};

export default PrimaryButton;

export const LoadablePrimaryButton = loadable(PrimaryButton);
